import gql from 'graphql-tag';

export const GET_STAGE_NOTES = gql`
  query GetStageNotes($input: StageNotesInput!) {
    bpf {
      result: stageNotes(input: $input) {
        error
        success
        list {
          id
          stageId
          content
          parentId
          parentType
          createdById
          createdDateTime
          modifiedDateTime
          createdBy {
            id
            fullName
          }
        }
      }
    }
  }
`;
